module.exports = __webpack_public_path__ + "static/media/twitter_icon.e304e3f0.svg";